import React from 'react'
import Page from '../../components/Page'
import Navbar from '../../components/Navbar'
import ImageProfile from '../../components/ImageProfile'
import Layout from '../../components/Layout'
import Text from '../../components/Text'
import Icon from '../../components/Icon'

class Home extends React.Component {
    render () {
        return (
            <Page>
                <Navbar/>
                <Layout direction="row">
                    <ImageProfile/>
                    <Layout direction="column">
                        <Text></Text>
                        <Layout direction="row">
                            <Icon Url="https://instagram.com/jessijess_99" Type="fas" Data="envelope-square"></Icon>
                            <Icon Url="https://github.com/munyaaa" Type="fab" Data="github"></Icon>
                            <Icon Url="https://linkedin.com/in/jessicajimantoro" Type="fab" Data="linkedin"></Icon>
                            <Icon Url="https://line.me/ti/p/~jessi_jess" Type="fab" Data="line"></Icon>
                            <Icon Url="https://instagram.com/jessijess_99" Type="fab" Data="instagram"></Icon>
                        </Layout>
                    </Layout>
                </Layout>
            </Page>
        )
    }
}

export default Home